<template>
  <data-cell-edit-dialog v-bind="$attrs">
    <template #cell="{ props, on }">
      <data-cell-text v-bind="props" v-on="on" />
    </template>
    <template #control="{ props, on }">
      <bm-number data-qa="number" v-bind="props" v-on="on" />
    </template>
  </data-cell-edit-dialog>
</template>

<script lang="ts">
import DataCellEditDialog from "@/components/controls/grid/renderers/editors/DataCellEditDialog.vue";
import DataCellText from "@/components/controls/grid/renderers/DataCellText.vue";
import Vue from "vue";
export default Vue.extend({
  name: "DataCellNumberEdit",
  components: { DataCellText, DataCellEditDialog },
  inheritAttrs: false,
});
</script>
